import { CryptoBalance, FiatBalance } from '@/features/Wallets/wallet.types'

export interface TransactionRequest {
  size: number;
  cardId?: string;
  endDate?: string;
  lastTxId?: string;
  solAddress?: string;
  splAddress?: string;
  startDate?: string;
  type?: string;
}

export interface TransactionConfirmRequest {
  cryptoBalance: CryptoBalance;
  type: string;
  wallet: string;
  redirectLink?: string;
  invoiceId?: string;
}

export interface ApproveDelegateData {
  cryptoAmount: CryptoBalance;
  delegationAddress: string;
  fromWalletAddress: string;
  type: 'APPROVE_DELEGATE';
}

export interface RevokeDelegateData {
  fromWalletAddress: string;
  mint: string;
  type: 'REVOKE_DELEGATE';
}

export interface CardSpendData {
  amount: CryptoBalance;
  cardAmount: FiatBalance;
  cardId: string;
  cardTransactionType: 'SPEND' | 'REVERSE' | 'REFUND' | 'CLEARING';
  cryptoChangeRate: string;
  feeAmount: string;
  interchangeRate: string;
  lastFourDigits: string;
  mcc: string;
  merchantIdentifier: string;
  merchantName: string;
  originalAmount: FiatBalance;
  type: 'CARD_TRANSACTION';
}

export interface CardPaymentTariffData {
  cryptoAmount: CryptoBalance;
  fromWalletAddress: string;
  invoiceId: string;
  invoiceType: 'CARD_SLOT_PAYMENT_TYPE' | string;
  memo: string;
  mint: string;
  title: string;
  toWalletAddress: string;
  type: 'PAYMENT';
}

export enum SolanaTransactionStatus {
  PROCESSED = 'PROCESSED',
  CONFIRMED = 'CONFIRMED',
  FINALIZED = 'FINALIZED',
  FAILED = 'FAILED'
}

export enum TransactionStatus {
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  ERROR_SEND = 'ERROR_SEND'
}

export interface TransactionData {
  createdAt: string;
  data: any;
  displayDateNotSendingTx: string;
  failedAt: string;
  failedReason: string;
  id: string;
  lastValidBlockHeight: number;
  solAddress: string;
  solanaStatus: SolanaTransactionStatus;
  solanaTxId: string;
  splAddress: string;
  status: TransactionStatus;
  updatedAt: string;
  validDateTime: string;
}

export interface TransactionDelegate extends TransactionData {
  data: ApproveDelegateData;
}

export interface TransactionCardSpend extends TransactionData {
  data: CardSpendData;
}

export interface TransactionRevokeDelegate extends TransactionData {
  data: RevokeDelegateData;
}

export interface TransactionCardClearing extends TransactionData {
  data: CardSpendData;
  linkedTransactionId: string;
}

export interface TransactionCardTariffPayment extends TransactionData {
  data: CardPaymentTariffData;
}
